export default __webpack_public_path__ + "static/media/login.f8b38322.jpg";